var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.02437 23.7914C1.01953 27.821 2.08188 31.7806 4.10434 35.2712L0.831055 47.1695L13.0622 43.9768C16.4451 45.8102 20.2354 46.7709 24.0871 46.7712H24.0973C36.8123 46.7712 47.1633 36.4704 47.1686 23.8096C47.171 17.6743 44.7731 11.9056 40.4169 7.56516C36.0615 3.2251 30.2686 0.833852 24.0965 0.831421C11.3794 0.831421 1.02966 11.131 1.02437 23.7914Z",
    fill: "url(#paint0_linear_282_8)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.02437 23.7914C1.01953 27.821 2.08188 31.7806 4.10434 35.2712L0.831055 47.1695L13.0622 43.9768C16.4451 45.8102 20.2354 46.7709 24.0871 46.7712H24.0973C36.8123 46.7712 47.1633 36.4704 47.1686 23.8096C47.171 17.6743 44.7731 11.9056 40.4169 7.56516C36.0615 3.2251 30.2686 0.833852 24.0965 0.831421C11.3794 0.831421 1.02966 11.131 1.02437 23.7914Z",
    fill: "url(#paint1_linear_282_8)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.200638 23.784C0.195641 27.958 1.29604 32.0595 3.3909 35.6751L0 48L12.6695 44.6927C16.1737 46.5924 20.1002 47.588 24.0903 47.5884H24.1005C37.2718 47.5884 47.9939 36.9169 48 23.8031C48.002 17.4474 45.5179 11.4713 41.0062 6.97522C36.4937 2.47998 30.4937 0.00243095 24.1005 0C10.9268 0 0.205928 10.6695 0.200638 23.784ZM7.74591 35.054L7.2726 34.3064C5.2831 31.155 4.23024 27.5074 4.23577 23.7853C4.23984 12.8853 13.1509 4.01756 24.1083 4.01756C29.414 4.01958 34.4006 6.0786 38.1517 9.81498C41.9023 13.5518 43.9661 18.5186 43.9645 23.8015C43.9596 34.7019 35.0489 43.5712 24.1001 43.5712H24.0928C20.5353 43.5714 17.0432 42.6196 13.982 40.8153L13.2563 40.3867L5.73832 42.3492L7.74551 35.054H7.74591Z",
    fill: "url(#paint2_linear_282_8)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1271 13.8406C17.6794 12.8508 17.2089 12.831 16.7836 12.8135C16.4353 12.7986 16.0369 12.7998 15.6392 12.7998C15.2404 12.7998 14.5937 12.9489 14.0468 13.5436C13.4994 14.1384 11.9565 15.5763 11.9565 18.5016C11.9565 21.4268 14.0964 24.2528 14.3947 24.6499C14.6934 25.0461 18.5259 31.2406 24.5955 33.6233C29.6403 35.6037 30.6667 35.2099 31.7615 35.1107C32.8562 35.0118 35.2948 33.6732 35.7921 32.2847C36.2899 30.8966 36.2899 29.7066 36.1405 29.4583C35.9915 29.2107 35.5931 29.0616 34.9961 28.7647C34.3987 28.4673 31.4627 27.029 30.9158 26.8304C30.368 26.6323 29.97 26.5334 29.5715 27.1286C29.1735 27.723 28.0299 29.0616 27.6816 29.4583C27.3332 29.8553 26.9844 29.9052 26.3874 29.6082C25.79 29.3096 23.8666 28.6824 21.5851 26.6574C19.8099 25.0814 18.6114 23.1358 18.263 22.5406C17.9146 21.9458 18.226 21.6241 18.5251 21.3276C18.7937 21.0614 19.1225 20.6335 19.4212 20.2863C19.7191 19.9391 19.8189 19.6915 20.0179 19.2949C20.2173 18.8978 20.1172 18.551 19.9682 18.2536C19.8188 17.9562 18.6582 15.0164 18.1271 13.8406Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_282_8",
    x1: 2317.71,
    y1: 4634.64,
    x2: 2317.71,
    y2: 0.831421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_282_8",
    x1: 2317.71,
    y1: 4634.64,
    x2: 2317.71,
    y2: 0.831421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_282_8",
    x1: 2400,
    y1: 4800,
    x2: 2400,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.527e5114cdbeb23210fe2a8246982ba0.svg";
export { ForwardRef as ReactComponent };